/*!
 * bm-popup-halloween.js - Pop-up Halloween -15 % - boutique Batman
 * v1.0.0 - 2026-10-06 - même moteur que le pop-up Halloween Spider-Man (en ligne depuis le 05/10)
 *
 * Chargé par sections/bm-popup-halloween.liquid, qui fournit :
 *   #bmph-config         les réglages (JSON) : langue, code, dates, délai…
 *   #bmph-form-template  le formulaire d'inscription natif de Shopify (form 'customer')
 *
 * Pour tout le monde (clients compris), jusqu'à la fin de l'offre (réglage « fin ») :
 *   - visiteur inconnu : il laisse son e-mail, le code s'affiche ;
 *   - déjà inscrit (pop-up de bienvenue, e-mail marketing, client connecté abonné) :
 *     le code s'affiche directement, sans redemander l'e-mail.
 * Compte à rebours en direct : « Halloween dans … » puis, le jour J, « Fin de l'offre dans … ».
 * Décor dessiné ici, sans aucun logo : nuit sur Gotham, lune, chauves-souris, citrouille masquée.
 *
 * Contrôle par l'adresse de la page :
 *   ?bmph=show   affiche le pop-up après 1 s, sans les règles d'affichage (inscription réelle)
 *   ?bmph=test   idem, inscription simulée (jamais sur le thème en ligne)
 *   ?bmph=reset  oublie ce que ce navigateur a mémorisé pour ce pop-up
 */
(function () {
  'use strict';
  if (window.__bmphBooted) return;
  window.__bmphBooted = true;

  var VERSION = '1.0.0';
  var SECTION_ID = 'bm-popup-halloween';
  var MIN_AFTER_LOAD = 2500;
  var RETRY_BUSY = 3000;
  var K = {
    got: 'bmph_got',           // code Halloween déjà obtenu : plus de pop-up
    snooze: 'bmph_snooze',     // fermé : pas de pop-up avant cette date (ms)
    known: 'bmph_known',       // abonné connu (arrivé depuis un e-mail marketing)
    t0: 'bmph_t0',             // début de la visite (sessionStorage)
    shown: 'bmph_shown',       // déjà montré pendant cette visite (sessionStorage)
    pending: 'bmph_pending',   // inscription partie par la page de vérification Shopify
    welcomeSub: 'bmpb_sub'     // inscrit par le pop-up de bienvenue
  };
  var EMAIL_RE = /^[^\s@<>(),;:\\[\]]+@[^\s@<>(),;:\\[\]]+\.[a-z\u00a1-\uffff]{2,}$/i;

  /* <T> textes (5 langues) — seul bloc avec des caractères accentués, échappés en \uXXXX à la livraison */
  var T = {
    fr: {
      dialog: 'Offre Halloween\u00a0: \u221215\u00a0% sur toute la boutique',
      pct: '\u221215\u00a0%', sub: 'jusqu\u2019au 31 octobre',
      eyebrow: 'Halloween arrive \u00e0 grands pas', title: '\u221215\u00a0% sur toute la boutique',
      text: 'Gotham se pare de citrouilles\u00a0: laisse ton e-mail, ton code Halloween s\u2019affiche tout de suite.',
      label: 'Ton adresse e-mail', placeholder: 'Ton adresse e-mail',
      cta: 'Je veux mon code Halloween', sending: 'Un instant\u2026', decline: 'Non merci',
      legal: 'En t\u2019inscrivant, tu acceptes de recevoir nos e-mails (nouveaut\u00e9s et offres). D\u00e9sinscription en un clic. Offre valable jusqu\u2019au 31 octobre 2026 \u00e0 23\u00a0h\u00a059.',
      privacy: 'Politique de confidentialit\u00e9',
      errEmail: 'Cette adresse e-mail n\u2019a pas l\u2019air valide.',
      errNetwork: 'Oups, \u00e7a n\u2019a pas march\u00e9. R\u00e9essaie dans un instant.',
      cdBefore: 'Halloween dans', cdDuring: 'C\u2019est Halloween\u202f! Fin de l\u2019offre dans',
      units: ['jours', 'heures', 'min', 'sec'],
      okTitle: 'Ton code Halloween est pr\u00eat\u202f!', okText: 'Voici ton code de r\u00e9duction\u00a0:',
      knownTitle: 'Tu fais d\u00e9j\u00e0 partie de la Bat-family\u202f!', knownText: 'Pas besoin de t\u2019inscrire\u00a0: voici ton code Halloween.',
      copy: 'Copier', copied: 'Copi\u00e9\u202f!',
      okApplied: 'Il est d\u00e9j\u00e0 appliqu\u00e9 \u00e0 ton panier\u00a0: \u221215\u00a0% au paiement.',
      okManual: 'Saisis-le au moment du paiement.',
      okNote: 'Valable sur toute la boutique jusqu\u2019au 31 octobre \u00e0 23\u00a0h\u00a059.',
      cont: 'Continuer mes achats', close: 'Fermer'
    },
    en: {
      dialog: 'Halloween offer: 15% off everything',
      pct: '\u221215%', sub: 'until 31 October',
      eyebrow: 'Halloween is creeping closer', title: '15% off everything',
      text: 'Gotham is getting spooky: drop your email and your Halloween code appears instantly.',
      label: 'Your email address', placeholder: 'Your email address',
      cta: 'Get my Halloween code', sending: 'One moment\u2026', decline: 'No thanks',
      legal: 'By signing up, you agree to receive our emails (new arrivals and offers). Unsubscribe in one click. Offer valid until 31 October 2026, 11:59 pm (Paris time).',
      privacy: 'Privacy policy',
      errEmail: 'This email address doesn\u2019t look valid.',
      errNetwork: 'Oops, that didn\u2019t work. Please try again in a moment.',
      cdBefore: 'Halloween in', cdDuring: 'It\u2019s Halloween! Offer ends in',
      units: ['days', 'hours', 'min', 'sec'],
      okTitle: 'Your Halloween code is ready!', okText: 'Here\u2019s your discount code:',
      knownTitle: 'You\u2019re already part of the Bat-family!', knownText: 'No need to sign up: here\u2019s your Halloween code.',
      copy: 'Copy', copied: 'Copied!',
      okApplied: 'It\u2019s already applied to your cart: 15% off at checkout.',
      okManual: 'Enter it at checkout.',
      okNote: 'Valid on everything until 31 October, 11:59 pm (Paris time).',
      cont: 'Continue shopping', close: 'Close'
    },
    de: {
      dialog: 'Halloween-Angebot: 15\u00a0% Rabatt auf alles',
      pct: '\u221215\u00a0%', sub: 'bis 31. Oktober',
      eyebrow: 'Halloween steht vor der T\u00fcr', title: '\u221215\u00a0% auf alles',
      text: 'In Gotham wird es gruselig: Gib deine E-Mail-Adresse ein, und dein Halloween-Code erscheint sofort.',
      label: 'Deine E-Mail-Adresse', placeholder: 'Deine E-Mail-Adresse',
      cta: 'Halloween-Code sichern', sending: 'Einen Moment\u00a0\u2026', decline: 'Nein, danke',
      legal: 'Mit deiner Anmeldung willigst du ein, unsere E-Mails (Neuheiten und Angebote) zu erhalten. Abmeldung jederzeit mit einem Klick. Angebot g\u00fcltig bis 31. Oktober 2026, 23:59 Uhr.',
      privacy: 'Datenschutzerkl\u00e4rung',
      errEmail: 'Diese E-Mail-Adresse scheint ung\u00fcltig zu sein.',
      errNetwork: 'Hoppla, das hat nicht geklappt. Bitte versuche es gleich noch einmal.',
      cdBefore: 'Halloween in', cdDuring: 'Es ist Halloween! Angebot endet in',
      units: ['Tage', 'Std.', 'Min.', 'Sek.'],
      okTitle: 'Dein Halloween-Code ist bereit!', okText: 'Hier ist dein Rabattcode:',
      knownTitle: 'Du geh\u00f6rst schon zur Bat-Familie!', knownText: 'Keine Anmeldung n\u00f6tig: Hier ist dein Halloween-Code.',
      copy: 'Kopieren', copied: 'Kopiert!',
      okApplied: 'Er ist bereits in deinem Warenkorb hinterlegt: \u221215\u00a0% an der Kasse.',
      okManual: 'Gib ihn an der Kasse ein.',
      okNote: 'G\u00fcltig auf alles bis 31. Oktober, 23:59 Uhr.',
      cont: 'Weiter einkaufen', close: 'Schlie\u00dfen'
    },
    es: {
      dialog: 'Oferta de Halloween: 15\u00a0% de descuento en todo',
      pct: '\u221215\u00a0%', sub: 'hasta el 31 de octubre',
      eyebrow: 'Halloween est\u00e1 a la vuelta de la esquina', title: '\u221215\u00a0% en toda la tienda',
      text: 'Gotham se pone terror\u00edfica: d\u00e9janos tu correo y tu c\u00f3digo de Halloween aparecer\u00e1 al instante.',
      label: 'Tu correo electr\u00f3nico', placeholder: 'Tu correo electr\u00f3nico',
      cta: 'Quiero mi c\u00f3digo de Halloween', sending: 'Un momento\u2026', decline: 'No, gracias',
      legal: 'Al suscribirte, aceptas recibir nuestros correos (novedades y ofertas). Puedes darte de baja con un clic. Oferta v\u00e1lida hasta el 31 de octubre de 2026 a las 23:59.',
      privacy: 'Pol\u00edtica de privacidad',
      errEmail: 'Esta direcci\u00f3n de correo no parece v\u00e1lida.',
      errNetwork: 'Vaya, algo ha fallado. Int\u00e9ntalo de nuevo en un momento.',
      cdBefore: 'Halloween en', cdDuring: '\u00a1Es Halloween! La oferta termina en',
      units: ['d\u00edas', 'horas', 'min', 'seg'],
      okTitle: '\u00a1Tu c\u00f3digo de Halloween est\u00e1 listo!', okText: 'Aqu\u00ed tienes tu c\u00f3digo de descuento:',
      knownTitle: '\u00a1Ya formas parte de la Bat-familia!', knownText: 'No hace falta suscribirte: aqu\u00ed tienes tu c\u00f3digo de Halloween.',
      copy: 'Copiar', copied: '\u00a1Copiado!',
      okApplied: 'Ya est\u00e1 aplicado a tu carrito: \u221215\u00a0% al pagar.',
      okManual: 'Introd\u00facelo al pagar.',
      okNote: 'V\u00e1lido en toda la tienda hasta el 31 de octubre a las 23:59.',
      cont: 'Seguir comprando', close: 'Cerrar'
    },
    it: {
      dialog: 'Offerta di Halloween: 15% di sconto su tutto',
      pct: '\u221215%', sub: 'fino al 31 ottobre',
      eyebrow: 'Halloween si avvicina', title: '\u221215% su tutto il negozio',
      text: 'Gotham si tinge di arancione: lascia la tua email e il codice di Halloween appare subito.',
      label: 'Il tuo indirizzo email', placeholder: 'Il tuo indirizzo email',
      cta: 'Voglio il codice di Halloween', sending: 'Un attimo\u2026', decline: 'No, grazie',
      legal: 'Iscrivendoti accetti di ricevere le nostre email (novit\u00e0 e offerte). Puoi annullare l\u2019iscrizione con un clic. Offerta valida fino al 31 ottobre 2026 alle 23:59.',
      privacy: 'Informativa sulla privacy',
      errEmail: 'Questo indirizzo email non sembra valido.',
      errNetwork: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
      cdBefore: 'Halloween tra', cdDuring: '\u00c8 Halloween! L\u2019offerta termina tra',
      units: ['giorni', 'ore', 'min', 'sec'],
      okTitle: 'Il tuo codice di Halloween \u00e8 pronto!', okText: 'Ecco il tuo codice sconto:',
      knownTitle: 'Fai gi\u00e0 parte della Bat-famiglia!', knownText: 'Non serve iscriverti: ecco il tuo codice di Halloween.',
      copy: 'Copia', copied: 'Copiato!',
      okApplied: '\u00c8 gi\u00e0 applicato al tuo carrello: \u221215% al momento del pagamento.',
      okManual: 'Inseriscilo al momento del pagamento.',
      okNote: 'Valido su tutto fino al 31 ottobre alle 23:59.',
      cont: 'Continua lo shopping', close: 'Chiudi'
    }
  };
  /* </T> */

  // --------------------------------------------------------------- styles (Shadow DOM)
  // Charte Batman (jaune #fcd000, noir #0a0a0a, texte #222) + accents Halloween orange. Police : Oswald.
  var CSS = [
    ':host{all:initial}',
    '*,*::before,*::after{box-sizing:border-box}',
    '[hidden]{display:none!important}',
    '.ov{--y:#fcd000;--y2:#ffd820;--k:#0a0a0a;--org:#ff7a1a;--org2:#c2410c;--txt:#222;--mut:#6b6b6b;--line:#d4d4d4;',
    '--fd:Oswald,"Arial Narrow","Helvetica Neue",Arial,sans-serif;',
    'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;',
    'padding:24px;background:rgba(6,4,12,.72);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;',
    'transition:opacity .28s ease;font-family:var(--fd);font-size:16px;line-height:1.4;',
    'color:var(--k);text-align:left;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;',
    'overscroll-behavior:contain;-webkit-tap-highlight-color:transparent}',
    '.ov.on{opacity:1}',
    '.dlg{position:relative;display:grid;grid-template-columns:42% 58%;width:100%;max-width:800px;',
    'max-height:calc(100vh - 48px);background:#fff;border-radius:16px;overflow:hidden;outline:none;',
    'box-shadow:0 30px 90px rgba(0,0,0,.6),0 0 0 1px rgba(255,122,26,.4);transform:translateY(16px) scale(.97);opacity:.4;',
    'transition:transform .34s cubic-bezier(.2,.8,.2,1),opacity .34s ease}',
    '.ov.on .dlg{transform:none;opacity:1}',
    /* panneau visuel : nuit d'Halloween sur Gotham */
    '.vis{position:relative;z-index:0;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;',
    'min-height:470px;padding:34px 28px 118px;color:#fff;',
    'background:radial-gradient(70% 50% at 80% 16%,rgba(255,176,60,.30) 0%,rgba(255,176,60,0) 62%),',
    'radial-gradient(95% 70% at 0% 100%,rgba(255,122,26,.40) 0%,rgba(255,122,26,0) 62%),',
    'linear-gradient(170deg,#2a1552 0%,#140c2b 52%,#07060d 100%)}',
    '.stars{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-4;opacity:.55;pointer-events:none;background-image:',
    'radial-gradient(1.3px 1.3px at 9% 9%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 52% 5%,#fff 50%,transparent 52%),',
    'radial-gradient(1.2px 1.2px at 44% 23%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 6% 40%,#fff 50%,transparent 52%),',
    'radial-gradient(1.1px 1.1px at 58% 38%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 33% 45%,#fff 50%,transparent 52%)}',
    '.moon{position:absolute;top:30px;right:24px;width:104px;height:104px;border-radius:50%;z-index:-3;',
    'background:radial-gradient(circle at 38% 36%,#fff8d9 0%,#ffe27a 40%,#fcd000 68%,#f59e0b 100%);',
    'box-shadow:0 0 44px 14px rgba(252,190,40,.36),0 0 120px 40px rgba(255,140,40,.18)}',
    '.moon::before,.moon::after{content:"";position:absolute;border-radius:50%;background:rgba(200,120,20,.26)}',
    '.moon::before{width:19px;height:19px;top:27px;left:57px}.moon::after{width:12px;height:12px;top:62px;left:32px}',
    '.bats{position:absolute;top:16px;right:4px;width:210px;height:130px;color:#050308;z-index:-2;pointer-events:none}',
    '.pk{position:absolute;top:28px;left:20px;width:116px;height:auto;z-index:0;pointer-events:none;',
    'filter:drop-shadow(0 8px 14px rgba(0,0,0,.55)) drop-shadow(0 0 16px rgba(255,140,30,.35));',
    'animation:bmphFloat 4.6s ease-in-out infinite}',
    '.pk .mouth,.pk .glint{animation:bmphFlicker 2.8s ease-in-out infinite}',
    '@keyframes bmphFloat{0%,100%{transform:translateY(0) rotate(-3deg)}50%{transform:translateY(-7px) rotate(3deg)}}',
    '@keyframes bmphFlicker{0%,100%{opacity:1}45%{opacity:.78}55%{opacity:.95}70%{opacity:.82}}',
    '.city{position:absolute;left:0;right:0;bottom:0;width:100%;height:50%;z-index:-1;color:#050308;pointer-events:none}',
    '.band{position:absolute;left:-25%;right:-25%;bottom:-54px;height:128px;transform:rotate(-8deg);',
    'background:linear-gradient(90deg,var(--org2),var(--org));box-shadow:0 -6px 0 rgba(0,0,0,.35);z-index:0}',
    '.band::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
    'background-image:radial-gradient(rgba(0,0,0,.22) 1.3px,transparent 1.7px);background-size:9px 9px}',
    '.off{position:relative;z-index:1;margin:0}',
    '.pct{display:inline-block;font-family:var(--fd);font-weight:700;font-size:98px;line-height:.95;letter-spacing:-.01em;',
    'white-space:nowrap;transform:skewX(-8deg);transform-origin:left bottom;color:#fff!important;',
    'text-shadow:4px 4px 0 var(--org),8px 8px 0 rgba(0,0,0,.55)}',
    '.sub{display:block;max-width:240px;margin-top:14px;font-size:14px;font-weight:700;line-height:1.3;',
    'letter-spacing:.14em;text-transform:uppercase;color:var(--y)!important;text-shadow:0 2px 8px rgba(0,0,0,.7)}',
    /* panneau formulaire */
    '.bd{position:relative;z-index:0;display:flex;flex-direction:column;justify-content:center;',
    'padding:40px 40px 28px;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.eb{display:flex;align-items:center;gap:8px;margin:0 0 10px;font-size:13px;font-weight:700;line-height:1.3;letter-spacing:.14em;',
    'text-transform:uppercase;color:var(--org2)!important}',
    '.eb svg{flex:none;width:26px;height:24px}',
    '.title{margin:0 0 14px;font-family:var(--fd);font-size:34px;font-weight:700;line-height:1.06;letter-spacing:.005em;',
    'text-transform:uppercase;color:var(--k)!important;outline:none}',
    '.text{margin:14px 0 18px;font-size:16px;line-height:1.5;color:var(--txt)!important}',
    /* compte à rebours */
    '.cd{margin:0}',
    '.cdl{margin:0 0 8px;font-size:13px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--k)!important}',
    '.cdg{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}',
    '.cdc{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:8px 4px 7px;border-radius:10px;',
    'background:linear-gradient(160deg,#1f1f1f,#0a0a0a);box-shadow:inset 0 0 0 1px rgba(255,122,26,.55)}',
    '.cdn{font-family:var(--fd);font-size:27px;font-weight:700;line-height:1;color:var(--y)!important;font-variant-numeric:tabular-nums}',
    '.cdu{margin-top:4px;font-size:11px;font-weight:400;letter-spacing:.08em;text-transform:uppercase;color:rgba(255,255,255,.75)!important}',
    '.fm{position:relative;margin:0}',
    '.in{display:block;width:100%;height:54px;margin:0;padding:0 16px;border:2px solid var(--line);border-radius:10px;',
    'background:#fff;color:var(--k);font:400 17px/1.2 var(--fd);letter-spacing:.02em;outline:none;',
    'box-shadow:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}',
    '.in::placeholder{color:#8a8a8a;opacity:1}',
    '.in:focus{border-color:var(--k);box-shadow:0 0 0 4px rgba(252,208,0,.6)}',
    '.in[aria-invalid="true"]{border-color:#b42318;box-shadow:0 0 0 4px rgba(180,35,24,.14)}',
    '.cta{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;',
    'margin:12px 0 0;padding:12px 20px;border:0;border-radius:10px;background:var(--y);color:var(--k)!important;',
    'font:700 18px/1.2 var(--fd);letter-spacing:.06em;text-transform:uppercase;',
    'text-align:center;cursor:pointer;box-shadow:0 5px 0 var(--k);-webkit-appearance:none;appearance:none;',
    'transition:transform .1s,box-shadow .1s,background-color .15s}',
    '.cta:hover{background:var(--y2)}',
    '.cta:active{transform:translateY(3px);box-shadow:0 2px 0 var(--k)}',
    '.cta:focus-visible,.copy:focus-visible,.no:focus-visible,.x:focus-visible,.legal a:focus-visible{outline:3px solid var(--k);outline-offset:3px}',
    '.cta[disabled]{cursor:progress;opacity:.82;transform:none}',
    '.cta svg{flex:none;width:18px;height:18px}',
    '.err{margin:10px 0 0;font-size:15px;line-height:1.4;color:#b42318!important}',
    '.err:empty{margin:0}',
    '.no{display:block;margin:12px auto 0;padding:6px 10px;border:0;background:none;color:var(--mut)!important;',
    'font:400 15px/1.3 var(--fd);letter-spacing:.02em;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.no:hover{color:var(--k)!important}',
    '.legal{margin:14px 0 0;font-size:12.5px;line-height:1.5;letter-spacing:.01em;color:var(--mut)!important}',
    '.legal a{color:var(--k)!important;text-decoration:underline;text-underline-offset:2px}',
    '.x{position:absolute;top:14px;right:14px;z-index:3;display:flex;align-items:center;justify-content:center;',
    'width:40px;height:40px;margin:0;padding:0;border:0;border-radius:50%;background:rgba(10,10,10,.07);',
    'color:var(--k);cursor:pointer;transition:background-color .15s,transform .2s}',
    '.x:hover{background:rgba(10,10,10,.14);transform:rotate(90deg)}',
    '.x svg{width:18px;height:18px}',
    '.sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',
    '.hp{position:absolute!important;left:-9999px;top:0;width:1px;height:1px;overflow:hidden}',
    /* étape « code » */
    '.okic{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:0 0 14px;border-radius:50%;',
    'background:var(--k);color:var(--y);box-shadow:0 0 0 7px rgba(255,122,26,.3)}',
    '.okic svg{width:30px;height:30px}',
    '.code{display:flex;align-items:center;gap:12px;margin:4px 0 12px;padding:10px 10px 10px 18px;',
    'border:2px dashed var(--org);border-radius:12px;background:#fff4e8;animation:bmphPop .45s cubic-bezier(.2,.9,.3,1.35)}',
    '.codev{flex:1;min-width:0;font-family:var(--fd);font-size:28px;font-weight:700;letter-spacing:.1em;line-height:1.15;',
    'color:var(--k)!important;overflow-wrap:anywhere;-webkit-user-select:all;user-select:all}',
    '.copy{flex:none;min-height:44px;margin:0;padding:0 16px;border:0;border-radius:8px;background:var(--k);color:var(--y)!important;',
    'font:700 15px/1 var(--fd);letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:background-color .15s,color .15s}',
    '.copy.ok{background:#1d7d46;color:#fff!important}',
    '.hint{margin:0 0 4px;font-size:16px;line-height:1.5;color:var(--txt)!important}',
    '.note{margin:0 0 14px;font-size:14px;line-height:1.5;color:var(--mut)!important}',
    '.s-ok .cd{margin:0 0 4px}',
    '.cta-cont{margin-top:16px}',
    '@keyframes bmphPop{from{transform:scale(.9);opacity:0}to{transform:none;opacity:1}}',
    /* téléphone : feuille qui monte du bas */
    '@media (max-width:719px){',
    '.ov{align-items:flex-end;padding:0;padding-bottom:var(--kb,0px)}',
    '.dlg{grid-template-columns:1fr;max-width:none;max-height:calc(100% - 12px);border-radius:20px 20px 0 0;transform:translateY(105%);opacity:1}',
    '.vis{min-height:0;flex-direction:row;align-items:center;justify-content:flex-start;padding:22px 64px 22px 22px}',
    '.off{display:flex;align-items:center;gap:14px}',
    '.pct{font-size:58px;text-shadow:3px 3px 0 var(--org),6px 6px 0 rgba(0,0,0,.5)}',
    '.sub{margin:0;max-width:112px;font-size:11.5px;letter-spacing:.12em}',
    '.band,.moon{display:none}',
    '.pk{top:50%;left:auto;right:56px;width:58px;margin-top:-27px}',
    '.moon{top:auto;bottom:-34px;right:110px;width:70px;height:70px;opacity:.8}',
    '.bats{top:2px;right:96px;width:120px;height:74px}',
    '.city{height:82%}.city .win{fill-opacity:.24}',
    '.x{top:12px;right:12px;background:rgba(255,255,255,.18);color:#fff}',
    '.x:hover{background:rgba(255,255,255,.3)}',
    '.x:focus-visible{outline-color:var(--y)}',
    '.bd{padding:20px 20px calc(16px + env(safe-area-inset-bottom,0px))}',
    '.title{font-size:26px;margin-bottom:10px}',
    '.text{margin:10px 0 12px;font-size:15px}',
    '.cdn{font-size:22px}.cdc{padding:7px 3px 5px}',
    '.cta{font-size:16px;letter-spacing:.04em;padding:12px 14px}',
    '.legal{margin-top:10px;font-size:12px}',
    '}',
    '@media (max-width:359px){.pct{font-size:48px}.title{font-size:23px}.bd{padding-left:16px;padding-right:16px}.vis{padding-left:16px}.cdn{font-size:19px}}',
    '@media (min-width:720px) and (max-height:660px){.vis{min-height:0;padding:24px 24px 100px}.pct{font-size:76px}',
    '.pk{width:88px}.bd{padding:26px 34px 20px}.title{font-size:28px}.text{margin:10px 0 12px}.legal{margin-top:10px}}',
    '@media (prefers-reduced-motion:reduce){.ov,.dlg,.cta,.x,.copy{transition:none!important}.code,.pk,.pk .mouth,.pk .glint{animation:none!important}.dlg{transform:none!important}}'
  ].join('');

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    go: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  // Chauve-souris générique (dessin original, ailes festonnées, sans pointe de queue) : ce n'est
  // PAS l'emblème officiel. Boîte 120 × 50.
  var BAT = 'M60 18L57 19L55 11L52.5 20C49 21 47 22 46 23C38 14 22 8 5 10C10 17 12 24 14 31Q21 24 28 33' +
    'Q35 27 42 37Q49 31 54 40C56 44 58 46 60 46C62 46 64 44 66 40Q71 31 78 37Q85 27 92 33Q99 24 106 31' +
    'C108 24 110 17 115 10C98 8 82 14 74 23C73 22 71 21 67.5 20L65 11L63 19Z';

  // Citrouille « masquée » (dessin original) : cagoule noire à oreilles pointues, yeux blancs en
  // fente, sourire sculpté qui luit. Boîte 120 × 112.
  function pumpkinSVG(cls) {
    return '<svg class="' + cls + '" viewBox="0 0 120 112" aria-hidden="true" focusable="false">' +
      '<ellipse cx="38" cy="70" rx="27" ry="36" fill="#d9480f"/><ellipse cx="82" cy="70" rx="27" ry="36" fill="#d9480f"/>' +
      '<ellipse cx="60" cy="70" rx="26" ry="40" fill="#ff7a1a"/>' +
      '<path d="M42 40c-6 18-6 42 0 62M78 40c6 18 6 42 0 62" fill="none" stroke="#a63a07" stroke-width="2" stroke-linecap="round" opacity=".55"/>' +
      '<path d="M14 66C13 50 22 39 34 35L31 6L49 30C53 29 57 28.5 60 28.5C63 28.5 67 29 71 30L89 6L86 35C98 39 107 50 106 66' +
        'C96 63 84 66 74 72C69 67 64 64 60 64C56 64 51 67 46 72C36 66 24 63 14 66Z" fill="#0a0a0a"/>' +
      '<path d="M27 52L50 57L47 63L30 60Z M93 52L70 57L73 63L90 60Z" fill="#fff"/>' +
      '<path class="mouth" d="M36 82Q60 100 84 82Q80 96 68 99L66 93L60 100L54 93L52 99Q40 96 36 82Z" fill="#fcd000" stroke="#7c2d12" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<ellipse class="glint" cx="60" cy="91" rx="15" ry="5" fill="#fff6c8" opacity=".55"/></svg>';
  }

  // Trois chauves-souris en vol (dont une devant la lune).
  function batsSVG() {
    return '<svg class="bats" viewBox="0 0 210 130" aria-hidden="true" focusable="false">' +
      '<path d="' + BAT + '" fill="currentColor" transform="translate(66 98) scale(.46) rotate(-16)"/>' +
      '<path d="' + BAT + '" fill="currentColor" transform="translate(28 18) scale(.36) rotate(8)"/>' +
      '<path d="' + BAT + '" fill="currentColor" transform="translate(60 92) scale(.28) rotate(-10)"/></svg>';
  }

  function r1(x) { return Math.round(x * 10) / 10; }

  // Skyline de Gotham (dessin original), fenêtres allumées en orange (graine fixe).
  function citySVG(cls, lit, winColor) {
    var W = 400, H = 170;
    var B = [ // [x, largeur, hauteur, toit] 0 plat · 1 flèche · 2 gradins · 3 château d'eau · 4 dôme · 5 pointe gothique
      [0, 30, 62, 0], [26, 24, 96, 1], [48, 38, 74, 3], [84, 22, 118, 5], [104, 44, 86, 2], [146, 30, 136, 2],
      [174, 36, 82, 0], [208, 24, 108, 1], [230, 48, 70, 0], [276, 28, 100, 4], [302, 40, 84, 2], [340, 26, 114, 5], [364, 36, 64, 0]
    ];
    var d = '', win = '', seed = 11, i, j, k;
    var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    for (i = 0; i < B.length; i++) {
      var x = B[i][0], w = B[i][1], h = B[i][2], roof = B[i][3], y = H - h, cx = x + w / 2;
      d += 'M' + x + ' ' + H + 'V' + y + 'H' + (x + w) + 'V' + H + 'Z';
      if (roof === 1) d += 'M' + r1(cx - 2.5) + ' ' + y + 'L' + r1(cx) + ' ' + (y - 28) + 'L' + r1(cx + 2.5) + ' ' + y + 'Z';
      if (roof === 2) d += 'M' + (x + 4) + ' ' + y + 'V' + (y - 10) + 'H' + (x + w - 4) + 'V' + y + 'Z' +
        'M' + (x + 9) + ' ' + (y - 10) + 'V' + (y - 19) + 'H' + (x + w - 9) + 'V' + (y - 10) + 'Z' +
        'M' + r1(cx - 0.8) + ' ' + (y - 19) + 'V' + (y - 36) + 'H' + r1(cx + 0.8) + 'V' + (y - 19) + 'Z';
      if (roof === 3) d += 'M' + (x + 9) + ' ' + y + 'V' + (y - 9) + 'H' + (x + 10.6) + 'V' + y + 'Z' +
        'M' + (x + 21) + ' ' + y + 'V' + (y - 9) + 'H' + (x + 22.6) + 'V' + y + 'Z' +
        'M' + (x + 6) + ' ' + (y - 9) + 'H' + (x + 26) + 'V' + (y - 21) + 'H' + (x + 6) + 'Z' +
        'M' + (x + 4.5) + ' ' + (y - 21) + 'L' + (x + 16) + ' ' + (y - 29) + 'L' + (x + 27.5) + ' ' + (y - 21) + 'Z';
      if (roof === 4) d += 'M' + x + ' ' + y + 'A' + r1(w / 2) + ' ' + r1(w / 2.3) + ' 0 0 1 ' + (x + w) + ' ' + y + 'Z' +
        'M' + r1(cx - 0.7) + ' ' + r1(y - w / 2.3) + 'V' + r1(y - w / 2.3 - 9) + 'H' + r1(cx + 0.7) + 'V' + r1(y - w / 2.3) + 'Z';
      if (roof === 5) d += 'M' + x + ' ' + y + 'L' + r1(cx) + ' ' + r1(y - w * 1.15) + 'L' + (x + w) + ' ' + y + 'Z' +
        'M' + r1(cx - 0.7) + ' ' + r1(y - w * 1.15) + 'V' + r1(y - w * 1.15 - 10) + 'H' + r1(cx + 0.7) + 'V' + r1(y - w * 1.15) + 'Z';
      for (j = y + 8; j < H - 6; j += 9) {
        for (k = x + 4; k < x + w - 5; k += 7) if (rnd() < lit) win += 'M' + k + ' ' + j + 'h3v4h-3z';
      }
    }
    return '<svg class="' + cls + '" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="currentColor"/>' +
      (win ? '<path class="win" d="' + win + '" fill="' + (winColor || '#ffb347') + '" fill-opacity=".75"/>' : '') + '</svg>';
  }

  // --------------------------------------------------------------- état
  var cfg, t, params, mode, forced, dry, reduced, coarse;
  var state = 'closed';
  var host = null, root = null, els = {}, lastFocus = null, sending = false, downOnBackdrop = false;
  var prevHtmlOverflow = null, timer = null;

  try { boot(); } catch (err) { if (window.console) console.warn('[bmph]', err); }

  function boot() {
    cfg = readConfig();
    if (!cfg) return;
    if (!('attachShadow' in Element.prototype) || !window.fetch || !window.URLSearchParams || !window.Promise) return;
    params = new URLSearchParams(window.location.search);
    mode = String(params.get('bmph') || '').toLowerCase();
    forced = mode === 'show' || mode === 'test';
    var onLiveTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    dry = !!cfg.designMode || (mode === 'test' && !onLiveTheme);
    reduced = mq('(prefers-reduced-motion: reduce)');
    coarse = mq('(pointer: coarse)');
    window.bmphPopup = { version: VERSION, open: function () { open({}); } };

    if (mode === 'reset') resetState();
    if (cfg.designMode) { setupEditor(); return; }
    if (!forced && ended()) return;

    // Arrivée depuis un e-mail marketing : abonné connu, le code s'affichera directement.
    if (/^e-?mail$/i.test(params.get('utm_medium') || '')) store(K.known, '1');

    var postedOk = params.get('customer_posted') === 'true';
    var postedExisting = !postedOk && params.get('form_type') === 'customer';
    if (sget(K.pending) === '1') {
      sdel(K.pending);
      if (postedOk || postedExisting) {
        store(K.got, '1');
        if (cfg.autoApply) applyCode();
        track('bmph_subscribe', { status: postedOk ? 'ok-verif' : 'existing-verif' });
        setTimeout(function () { open({ success: true }); }, 400);
        return;
      }
    }

    if (!forced && !eligible()) return;
    schedule();
  }

  function readConfig() {
    var el = document.getElementById('bmph-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent || '{}');
      return c && typeof c === 'object' ? c : null;
    } catch (e) { return null; }
  }

  function langOf(c) { return String((c && c.locale) || 'fr').toLowerCase().split(/[-_]/)[0]; }
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }
  function finMs() { var v = Number(cfg.fin); return isFinite(v) && v > 0 ? v : 0; }
  function jourJMs() { var v = Number(cfg.jourJ); return isFinite(v) && v > 0 ? v : 0; }
  function ended() { return !!finMs() && Date.now() > finMs(); }

  // --------------------------------------------------------------- mémoire du navigateur
  function store(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { cookieSet(k, v, 60); } }
  function load(k) {
    var v = null;
    try { v = window.localStorage.getItem(k); } catch (e) { /* stockage bloqué */ }
    return v !== null ? v : cookieGet(k);
  }
  function unstore(k) { try { window.localStorage.removeItem(k); } catch (e) { /* rien */ } cookieSet(k, '', -1); }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* rien */ } }
  function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* rien */ } }
  function cookieGet(k) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(k, v, days) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) +
        '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* rien */ }
  }
  function resetState() {
    [K.got, K.snooze, K.known].forEach(unstore);
    [K.t0, K.shown, K.pending].forEach(sdel);
  }
  // Abonné connu : inscrit par le pop-up de bienvenue, arrivé d'un e-mail, ou client connecté abonné.
  function known() { return load(K.welcomeSub) === '1' || load(K.known) === '1' || cfg.known === true; }

  // --------------------------------------------------------------- qui voit le pop-up
  function eligible() {
    if (!cfg.enabled || !String(cfg.code || '').trim()) return false;
    if (ended()) return false;
    if (isBot()) return false;
    if (load(K.got) === '1') return false;
    if (sget(K.shown) === '1') return false;
    var until = parseInt(load(K.snooze) || '0', 10);
    if (until && Date.now() < until) return false;
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|challenge|password|policies|checkouts?)(?:[\/?#]|$)/i.test(window.location.pathname)) return false;
    return true;
  }

  function isBot() {
    return /googlebot|adsbot|storebot|google-inspectiontool|bingbot|bingpreview|yandex(?:bot|images|mobilebot)|baiduspider|duckduckbot|applebot|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|slurp|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|embedly|crawler|spider|lighthouse|pagespeed|headlesschrome|bot\//i
      .test(navigator.userAgent || '');
  }

  function delayMs() {
    var d = Number(cfg.delay);
    if (!isFinite(d)) d = 10;
    return Math.min(Math.max(d, 0), 600) * 1000;
  }
  function reshowMs() {
    var d = Number(cfg.reshowDays);
    if (!isFinite(d) || d < 1) d = 4;
    return Math.min(d, 365) * 864e5;
  }

  function schedule() {
    var now = Date.now();
    var t0 = parseInt(sget(K.t0) || '', 10);
    if (!(t0 > 0) || t0 > now) {
      t0 = (window.performance && performance.timeOrigin) ? Math.round(performance.timeOrigin) : now;
      sset(K.t0, String(t0));
    }
    var wait = forced ? 1000 : Math.max(delayMs() - (now - t0), MIN_AFTER_LOAD);
    setTimeout(tryOpen, wait);
  }

  function tryOpen() {
    if (state !== 'closed') return;
    if (!forced && !eligible()) return;
    if (document.hidden) {
      var onVis = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        setTimeout(tryOpen, 1500);
      };
      document.addEventListener('visibilitychange', onVis);
      return;
    }
    if (busy()) { setTimeout(tryOpen, RETRY_BUSY); return; }
    open({});
  }

  // Thème Craft : menu mobile -> body.overflow-hidden-tablet, recherche -> body.overflow-hidden,
  // menus déroulants et sélecteurs pays/langue -> details[open] / aria-expanded dans l'en-tête.
  function busy() {
    var a = document.activeElement;
    if (a && a !== document.body) {
      if (a.isContentEditable || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') return true;
      if (a.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(a.type || '')) return true;
    }
    var b = document.body, h = document.documentElement;
    if (/(?:^|\s)(?:modal-open|js-drawer-open|overflow-hidden(?:-mobile|-tablet|-desktop)?)(?:\s|$)/.test(b.className || '')) return true;
    try {
      if (getComputedStyle(b).overflowY === 'hidden' || getComputedStyle(h).overflowY === 'hidden') return true;
      if (document.querySelector('.header details[open], header details[open], .header-wrapper details[open], ' +
        '.disclosure__button[aria-expanded="true"]')) return true;
    } catch (e) { /* rien */ }
    return false;
  }

  // --------------------------------------------------------------- éditeur de thème
  function setupEditor() {
    var ours = function (e) {
      return !!e && ((e.detail && e.detail.sectionId === SECTION_ID) ||
        (e.target && e.target.id === 'shopify-section-' + SECTION_ID));
    };
    document.addEventListener('shopify:section:select', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') teardown();
      open({});
    });
    document.addEventListener('shopify:section:deselect', function (e) { if (ours(e)) close('editor'); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') { teardown(); open({}); }
    });
  }

  // --------------------------------------------------------------- construction
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function countdownHTML(id) {
    var u = t.units;
    return '<div class="cd" aria-live="off">' +
      '<p class="cdl" id="' + id + '"></p>' +
      '<div class="cdg">' +
        '<span class="cdc"><span class="cdn" data-u="d">00</span><span class="cdu">' + esc(u[0]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="h">00</span><span class="cdu">' + esc(u[1]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="m">00</span><span class="cdu">' + esc(u[2]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="s">00</span><span class="cdu">' + esc(u[3]) + '</span></span>' +
      '</div></div>';
  }

  function markup() {
    var code = String(cfg.code || '').trim();
    return '' +
      '<div class="ov" part="overlay">' +
        '<div class="dlg" role="dialog" aria-modal="true" aria-labelledby="bmph-t1" aria-describedby="bmph-d1" tabindex="-1">' +
          '<button type="button" class="x" aria-label="' + esc(t.close) + '">' + ICON.x + '</button>' +
          '<div class="vis"><span class="stars" aria-hidden="true"></span><span class="moon" aria-hidden="true"></span>' +
            batsSVG() + pumpkinSVG('pk') + citySVG('city', 0.32) + '<div class="band"></div>' +
            '<p class="off"><span class="pct">' + esc(t.pct) + '</span><span class="sub">' + esc(t.sub) + '</span></p>' +
          '</div>' +
          '<div class="bd">' +
            '<div class="s-form">' +
              '<p class="eb">' + pumpkinSVG('pki') + '<span>' + esc(t.eyebrow) + '</span></p>' +
              '<h2 class="title" id="bmph-t1">' + esc(t.title) + '</h2>' +
              countdownHTML('bmph-cd1') +
              '<p class="text" id="bmph-d1">' + esc(t.text) + '</p>' +
              '<form class="fm" novalidate>' +
                '<label class="sr" for="bmph-email">' + esc(t.label) + '</label>' +
                '<input class="in" id="bmph-email" type="email" name="contact[email]" required autocomplete="email" inputmode="email"' +
                  ' autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="send" aria-describedby="bmph-err"' +
                  ' placeholder="' + esc(t.placeholder) + '">' +
                '<div class="hp" aria-hidden="true"><input type="text" name="bmph_website" tabindex="-1" autocomplete="off"></div>' +
                '<button type="submit" class="cta cta-go"><span class="lbl">' + esc(t.cta) + '</span>' + ICON.go + '</button>' +
                '<p class="err" id="bmph-err" role="alert" aria-live="assertive"></p>' +
              '</form>' +
              '<button type="button" class="no">' + esc(t.decline) + '</button>' +
              '<p class="legal">' + esc(t.legal) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') +
                '" target="_blank" rel="noopener">' + esc(t.privacy) + '</a></p>' +
            '</div>' +
            '<div class="s-ok" hidden>' +
              '<div class="okic">' + ICON.ok + '</div>' +
              '<h2 class="title" id="bmph-t2" tabindex="-1">' + esc(t.okTitle) + '</h2>' +
              '<p class="text" style="margin:0 0 10px">' + esc(t.okText) + '</p>' +
              '<div class="code"><span class="codev">' + esc(code) + '</span>' +
                '<button type="button" class="copy">' + esc(t.copy) + '</button></div>' +
              '<p class="hint">' + esc(cfg.autoApply ? t.okApplied : t.okManual) + '</p>' +
              '<p class="note">' + esc(t.okNote) + '</p>' +
              countdownHTML('bmph-cd2') +
              '<button type="button" class="cta cta-cont">' + esc(t.cont) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function build() {
    destroyNow();
    t = T[langOf(cfg)] || T.en;
    host = document.createElement('div');
    host.id = 'bmph-host';
    // z-index maximal : au-dessus de la bulle Shopify Inbox (2147483000). Le défi hCaptcha, ajouté après, reste au-dessus.
    host.setAttribute('style', 'position:relative!important;z-index:2147483647!important;display:block!important;');
    root = host.attachShadow({ mode: 'open' });
    root.innerHTML = '<style>' + CSS + '</style>' + markup();
    document.body.appendChild(host);

    var $ = function (s) { return root.querySelector(s); };
    els = {
      ov: $('.ov'), dlg: $('.dlg'), form: $('.fm'), email: $('.in'), hp: $('.hp input'),
      go: $('.cta-go'), lbl: $('.cta-go .lbl'), err: $('.err'), stepForm: $('.s-form'), stepOk: $('.s-ok'),
      okTitle: $('#bmph-t2'), okText: $('.s-ok .text'), copy: $('.copy'), x: $('.x'), no: $('.no'), cont: $('.cta-cont')
    };
    if (cfg.email) els.email.value = String(cfg.email);

    els.ov.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === els.ov; });
    els.ov.addEventListener('click', function (e) {
      if (e.target === els.ov && downOnBackdrop) close('backdrop');
      downOnBackdrop = false;
    });
    els.x.addEventListener('click', function () { close('x'); });
    els.no.addEventListener('click', function () { close('decline'); });
    els.cont.addEventListener('click', function () { close('done'); });
    els.copy.addEventListener('click', copyCode);
    els.form.addEventListener('submit', onSubmit);
    els.email.addEventListener('input', function () {
      if (els.err.textContent) { els.err.textContent = ''; els.email.removeAttribute('aria-invalid'); }
    });
    tick();
  }

  // Compte à rebours : jusqu'au jour J (« Halloween dans »), puis jusqu'à la fin de l'offre.
  function tick() {
    if (!root) return;
    var now = Date.now(), jj = jourJMs(), fin = finMs();
    var during = !!jj && now >= jj;
    var target = during ? fin : (jj || fin);
    var left = Math.max(0, target - now);
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var label = during ? t.cdDuring : t.cdBefore;
    Array.prototype.forEach.call(root.querySelectorAll('.cdl'), function (n) { n.textContent = label; });
    Array.prototype.forEach.call(root.querySelectorAll('.cdn'), function (n) {
      var u = n.getAttribute('data-u');
      n.textContent = u === 'd' ? String(d) : pad(u === 'h' ? h : u === 'm' ? m : s);
    });
    if (fin && now > fin && state === 'open') { close('fin'); return; }
  }
  function startTicking() { stopTicking(); timer = setInterval(tick, 1000); }
  function stopTicking() { if (timer) { clearInterval(timer); timer = null; } }

  function destroyNow() {
    stopTicking();
    if (host && host.parentNode) host.parentNode.removeChild(host);
    host = null; root = null; els = {};
    state = 'closed';
  }

  function teardown() {
    document.removeEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewport);
      window.visualViewport.removeEventListener('scroll', onViewport);
    }
    unlockScroll();
    destroyNow();
  }

  // --------------------------------------------------------------- ouverture / fermeture
  function open(opts) {
    opts = opts || {};
    if (state !== 'closed' || !document.body) return;
    build();
    state = 'open';
    startTicking();
    if (!forced && !dry && !opts.success) sset(K.shown, '1');
    lastFocus = document.activeElement;
    lockScroll();
    document.addEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }
    var direct = !opts.success && !cfg.designMode && known();
    if (opts.success) showSuccess(true, false);
    else if (direct) {
      // abonné déjà connu : pas d'e-mail à redemander, le code s'affiche tout de suite
      showSuccess(true, true);
      if (!dry) { store(K.got, '1'); if (cfg.autoApply) applyCode(); }
    }
    if (reduced) els.ov.classList.add('on');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (els.ov) els.ov.classList.add('on'); }); });
    setTimeout(function () {
      if (state !== 'open') return;
      var target = (opts.success || direct) ? els.okTitle : (coarse ? els.dlg : els.email);
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }, reduced ? 0 : 80);
    track('bmph_view', { success: !!opts.success, direct: direct });
  }

  function close(reason) {
    if (state !== 'open') return;
    state = 'closing';
    if (!dry && reason !== 'editor' && reason !== 'fin' && load(K.got) !== '1') store(K.snooze, String(Date.now() + reshowMs()));
    document.removeEventListener('keydown', onKey, true);
    unlockScroll();
    if (els.ov) els.ov.classList.remove('on');
    var finish = function () {
      if (state !== 'closing') return;
      teardown();
      var f = lastFocus;
      lastFocus = null;
      if (f && f.focus && document.documentElement.contains(f)) {
        try { f.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      }
    };
    if (reduced) finish(); else setTimeout(finish, 320);
    track('bmph_close', { reason: reason });
  }

  function lockScroll() {
    var h = document.documentElement;
    if (window.innerWidth - h.clientWidth > 0) return;
    prevHtmlOverflow = h.style.overflow;
    h.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (prevHtmlOverflow === null) return;
    document.documentElement.style.overflow = prevHtmlOverflow;
    prevHtmlOverflow = null;
  }

  function onViewport() {
    var vv = window.visualViewport;
    if (!vv || !els.ov) return;
    var kb = Math.round(window.innerHeight - vv.height - vv.offsetTop);
    els.ov.style.setProperty('--kb', (kb > 60 ? kb : 0) + 'px');
  }

  function focusables() {
    var list = els.dlg.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (n) { return n.offsetParent !== null; });
  }

  function onKey(e) {
    if (state !== 'open') return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], cur = root.activeElement;
    if (e.shiftKey && (cur === first || !cur || cur === els.dlg || cur === els.okTitle)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (cur === last || !cur)) { e.preventDefault(); first.focus(); }
  }

  // --------------------------------------------------------------- inscription
  function onSubmit(e) {
    e.preventDefault();
    if (sending) return;
    var email = String(els.email.value || '').trim();
    if (!EMAIL_RE.test(email)) { fail('email'); return; }
    if (els.hp.value) { succeed('hp'); return; }
    setSending(true);
    var slow = setTimeout(function () { setSending(false); }, 12000);
    (dry ? simulate(email) : send(email)).then(function (outcome) {
      clearTimeout(slow);
      handle(outcome, email);
    }, function () {
      clearTimeout(slow);
      handle('network', email);
    });
  }

  function handle(outcome, email) {
    setSending(false);
    if (outcome === 'ok' || outcome === 'existing' || outcome === 'unknown') { succeed(outcome); return; }
    if (state !== 'open') return;
    if (outcome === 'challenge') { nativeSubmit(email); return; }
    fail(outcome === 'invalid' ? 'email' : 'network');
  }

  function setSending(on) {
    sending = !!on;
    if (!els.go) return;
    els.go.disabled = sending;
    els.go.setAttribute('aria-busy', sending ? 'true' : 'false');
    els.lbl.textContent = sending ? t.sending : t.cta;
  }

  function fail(kind) {
    if (state !== 'open') return;
    els.err.textContent = kind === 'email' ? t.errEmail : t.errNetwork;
    if (kind === 'email') {
      els.email.setAttribute('aria-invalid', 'true');
      try { els.email.focus({ preventScroll: true }); } catch (e) { els.email.focus(); }
    }
  }

  function succeed(kind) {
    if (!dry) { store(K.got, '1'); store(K.welcomeSub, '1'); }
    if (!dry && cfg.autoApply && kind !== 'hp') applyCode();
    track('bmph_subscribe', { status: kind, simulated: dry });
    if (state === 'open') showSuccess(false, false);
  }

  function showSuccess(instant, direct) {
    els.stepForm.hidden = true;
    els.stepOk.hidden = false;
    if (direct) {
      els.okTitle.textContent = t.knownTitle;
      els.okText.textContent = t.knownText;
    }
    els.dlg.setAttribute('aria-labelledby', 'bmph-t2');
    els.dlg.removeAttribute('aria-describedby');
    tick();
    if (!instant) setTimeout(function () {
      if (state !== 'open') return;
      try { els.okTitle.focus({ preventScroll: true }); } catch (e) { els.okTitle.focus(); }
    }, 30);
  }

  function templateForm() {
    var tpl = document.getElementById('bmph-form-template');
    return tpl && tpl.content ? tpl.content.querySelector('form') : null;
  }

  var mirrors = 0;
  function makeMirror(email) {
    var src = templateForm();
    var f = document.createElement('form');
    f.id = 'bmph-mirror-' + (++mirrors);
    f.method = 'post';
    f.setAttribute('action', (src && src.getAttribute('action') ? src.getAttribute('action') : '/contact').split('#')[0]);
    f.setAttribute('accept-charset', 'UTF-8');
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('style', 'position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;' +
      'height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;');
    var hidden = src ? src.querySelectorAll('input[type="hidden"]') : [];
    if (hidden.length) {
      Array.prototype.forEach.call(hidden, function (inp) {
        if (!inp.name) return;
        f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: inp.name, value: inp.value }));
      });
    } else {
      [['form_type', 'customer'], ['utf8', '\u2713'],
       ['contact[tags]', 'newsletter,pop-up email,pop-up email ' + langOf(cfg) + ',pop-up halloween']]
        .forEach(function (p) { f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: p[0], value: p[1] })); });
    }
    var em = Object.assign(document.createElement('input'), { type: 'hidden', name: 'contact[email]', value: email });
    em.setAttribute('value', email);
    f.appendChild(em);
    document.body.appendChild(f);
    return f;
  }

  function removeMirror(f) {
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }

  function send(email) {
    return new Promise(function (resolve) {
      var settled = false, posted = false;
      var mirror = makeMirror(email);
      var finish = function (outcome) {
        if (settled) return;
        settled = true;
        removeMirror(mirror);
        resolve(outcome);
      };
      var ajax = function () {
        if (posted) return;
        posted = true;
        post(mirror).then(finish, function () { finish('network'); });
      };
      mirror.submit = ajax;   // Shopify appellera cette fonction une fois le jeton anti-robot ajouté
      var cap = window.Shopify && window.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var bound = false;
        try {
          cap.protect(mirror, function () {
            bound = true;
            try { mirror.submit(); } catch (err) { ajax(); }
          });
        } catch (err) { ajax(); return; }
        setTimeout(function () { if (!bound) ajax(); }, 20000);
        setTimeout(function () { finish('timeout'); }, 120000);
      } else {
        ajax();
      }
    });
  }

  function post(form) {
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { body.append(k, v); });
    var ctrl = window.AbortController ? new AbortController() : null;
    var tm = ctrl ? setTimeout(function () { ctrl.abort(); }, 25000) : null;
    return fetch(form.getAttribute('action'), {
      method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow',
      headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (tm) clearTimeout(tm);
      var url = res.url || '';
      if (/\/challenge(?:[\/?#]|$)/.test(url)) return 'challenge';
      if (!res.ok) return 'http';
      return res.text().then(function (html) { return classify(url, html); }, function () { return classify(url, ''); });
    });
  }

  function classify(url, html) {
    var m = /data-bmph-state="(ok|error)"(?:\s+data-bmph-errors="([^"]*)")?/.exec(html || '');
    if (/[?&]customer_posted=true/.test(url) || (m && m[1] === 'ok')) return 'ok';
    if (m && m[1] === 'error') return /email/i.test(m[2] || '') ? 'invalid' : 'error';
    if (/[?&]form_type=customer/.test(url)) return 'existing';
    return 'unknown';
  }

  function nativeSubmit(email) {
    sset(K.pending, '1');
    var f = makeMirror(email);
    HTMLFormElement.prototype.submit.call(f);
  }

  function simulate(email) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(/panne/i.test(email) ? 'http' : /erreur/i.test(email) ? 'invalid' : /existe/i.test(email) ? 'existing' : 'ok');
      }, 700);
    });
  }

  function applyCode() {
    var code = String(cfg.code || '').trim();
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'),
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () { /* rien */ });
    } catch (e) { /* rien */ }
  }

  function copyCode() {
    var code = String(cfg.code || '').trim();
    var btn = els.copy;
    var done = function () {
      if (!btn) return;
      btn.textContent = t.copied;
      btn.classList.add('ok');
      track('bmph_copy', {});
      setTimeout(function () { if (btn) { btn.textContent = t.copy; btn.classList.remove('ok'); } }, 2200);
    };
    var legacy = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.setAttribute('style', 'position:fixed;top:-1000px;left:0;opacity:0;');
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      try { btn.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      if (ok) done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, legacy);
    else legacy();
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = { locale: langOf(cfg), version: VERSION };
        for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* rien */ }
  }
})();
